module.exports = __webpack_public_path__ + "static/Inter-italic.var-subset-b850defff6a5dd08ab5b60d16fd28a87.woff2";